export interface StampProps {
  /**
   * Status of the stamp component
   */
  status: StampStatus;
  /**
   * Stamp size (default large)
   */
  size?: "small" | "large";
  /**
   * Stamp variant (default hard)
   */
  variant?: "soft" | "hard";
  /**
   * Date of which the difference is calculated against today's date
   * ex) 02d 10h 15m
   */
  deadline?: Date;
  /**
   * Display an ETA status stale indicator
   */
  withIndicator?: boolean;
}

export enum StampStatus {
  notAssigned = "not assigned",
  notTracking = "not tracking",
  atRisk = "at risk",
  awaitingEta = "awaiting eta",
  expired = "expired",
  delivered = "delivered",
  early = "early",
  onTime = "on time",
  late = "late",
  veryLate = "very late",
}
